import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CancelShipmentReasonEntity } from '../../domain/entities/CancelShipmentReasonEntity'

export class CancelShipmentReasonModel extends CancelShipmentReasonEntity {
  constructor(dataDto: CancelShipmentReasonModel) {
    super()
    mapEntityProperties<CancelShipmentReasonEntity>(this, dataDto)
  }
}
